/**
 * @fileoverview dav store的hook，用于跟随系统动态修改c7n全局日期时间格式
 */
import { configure } from 'choerodon-ui';
import { DEFAULT_DATETIME_FORMAT } from 'utils/constants';

// let prevTimeZone: string;
// let prevDateFormat: string;
// let prevDateTimeFormat: string;
// let prevTimeFormat: string;

export default function ChangeDateTimeFormatterHook() {
  return () => (next) => (action) => {
    if (!action) {
      return next(action);
    }

    // 需要try-catch,避免emitter事件监听器中抛出的异常，引起dva崩溃
    try {
      const { type = '', payload = {} } = action;
      if (['user/updateCurrentUser', 'user/saveCurrentUser'].includes(type)) {
        const { timeZone, dateFormat, dateTimeFormat, timeFormat, dataTimeFormat, ...reset } =
          payload;
        // const isSameTimeZone =
        //   prevTimeZone && payload.timeZone && prevTimeZone !== payload.timeZone;
        // const isSameDateFormat =
        //   prevDateFormat && payload.dateFormat && prevDateFormat !== payload.dateFormat;
        // const isSameDateTimeFormat =
        //   prevDateTimeFormat &&
        //   payload.dateTimeFormat &&
        //   prevDateTimeFormat !== payload.dateTimeFormat;
        // const isSameTimeFormat =
        //   prevTimeFormat && payload.timeFormat && prevTimeFormat !== payload.timeFormat;
        // 对“个人中心”-“偏好设置”做更新操作，需要刷新系统页面
        if (
          !reset.loginName &&
          (timeZone || dateFormat || dateTimeFormat || timeFormat || dataTimeFormat)
        ) {
          window.location.reload();
          return;
        }
        // prevTimeZone = payload.timeZone;
        // prevDateFormat = payload.dateFormat;
        // prevDateTimeFormat = payload.dateTimeFormat;
        // prevTimeFormat = payload.timeFormat;
        configure({
          formatter: {
            jsonDate: DEFAULT_DATETIME_FORMAT,
            date: payload.dateFormat,
            dateTime: payload.dateTimeFormat,
            time: payload.timeFormat,
            year: 'YYYY',
            month: 'YYYY-MM',
            week: 'GGGG-Wo',
            timeZone: () => {
              return '';
            },
          },
        });
      }
    } catch (err) {
      /** noop */
    }
    return next(action);
  };
}
